//import { sylvanus } from '~/services/serviceInstances';

export const adminRepublishModel = async () =>
  // {
  //   modelId,
  //   version,
  //   publishMode,
  //   overrideScope,
  // }: {
  //   modelId: string;
  //   version: number;
  //   publishMode: string;
  //   overrideScope: any;
  // }
  {
    //mock a call with params
    const mockResponse: { success: boolean } = {
      success: true,
    };
    return Promise.resolve(mockResponse);
  };
